import React from "react";
import './blogs.css'
import Header from '../../Components/Header/header';
import '../../Assets/profile.jpg'
import { Link } from "react-router-dom";

const Blogs = () => {
    return (
        <>
             <head>
                <title>Blogs</title>
                <meta charset="UTF-8"/>
                <meta name="description" content="Blogs page for Thomas Lee Williams
                personal website"/>
                <meta name="keywords" content="HTML, CSS, JavaScript, React"/>
                <meta name="author" content="Thomas Lee Williams"/>
                <meta name="viewport" content="width=device-width, initial-scale=1.0"/> 
            </head>
            <div className="main_blog">
                <Header/>
                <div className="page_blog">
                    <h1 className="name_blog">Blogs</h1>
                    <p className="desc_blog">
                        Here is where I am going to be keeping a account of random opinions, 
                        thoughts, events, and special occations varying from programming, to networking,
                         to anything else I seem to get up to in life. I don't lead a very glamorous
                        life, but it's mine and I want to share that life with people, in my own way.
                    </p>
                    <div className="blog_container">
                        <Link to="/blogs/cobies-birthday-2024">
                            <img src={require('../../Assets/Cobie Birthday.jpg')} className="blog_image"
                            alt="thumbnail-for-post"/>
                        </Link>
                        <div className="blog_title_and_desc">
                            <Link to="/blogs/cobies-birthday-2024">
                                <div className="blog_title">
                                    <h2><b>Cobies Birthday - 2024</b></h2>
                                </div>
                            </Link>
                            <div className="blog_desc_sub">
                                In the beginning of 2024, my friend Cobie had a birthday party 
                                and to celebrate her birthday, we went out for an italian meal 
                                and saw Boy and the Heron.
                            </div>
                        </div>
                    </div>
                    <div className="blog_container_after_first">
                        <Link to="/blogs/new-years-eve-2023">
                            <img src={require('../../Assets/New Year.jpg')} className="blog_image"
                            alt="thumbnail-for-post"/>
                        </Link>
                        <div className="blog_title_and_desc">
                            <Link to="/blogs/new-years-eve-2023">
                                <div className="blog_title">
                                    <h2><b>New Years Eve - 2023</b></h2>
                                </div>
                            </Link>
                            <div className="blog_desc_sub">
                                On the last day of 2023, me and my friends got together to celebrate
                                the new year with a wonderful meal at a hotpot, where the 
                                tiktok boys were born and bibs were worn.
                            </div>
                        </div>
                    </div>
                    <div className="blog_container_after_first">
                        <Link to="/blogs/amigomas-2023">
                            <img src={require('../../Assets/Amigomas-1.jpg')} className="blog_image"
                            alt="thumbnail-for-post"/>
                        </Link>
                        <div className="blog_title_and_desc">
                            <Link to="/blogs/amigomas-2023">
                                <div className="blog_title">
                                    <h2><b>Amigomas - 2023</b></h2>
                                </div>
                            </Link>
                            <div className="blog_desc_sub">
                                This was a duel celebration for us, we celebrated both Christmas and
                                my friend matthews birthday. We had a wonderful meal made by my friends 
                                Em and Tyler, we played some games and unvailed the best cake in human history.
                            </div>
                        </div>
                    </div>
                    <div className="blog_container_after_first">
                        <Link to="/blogs/lovejoy-concert-2023">
                            <img src={require('../../Assets/Lovejoy-1.jpg')} className="blog_image"
                            alt="thumbnail-for-post"/>
                        </Link>
                        <div className="blog_title_and_desc">
                            <Link to="/blogs/lovejoy-concert-2023">
                                <div className="blog_title">
                                    <h2><b>Lovejoy Concert - 2023</b></h2>
                                </div>
                            </Link>
                            <div className="blog_desc_sub">
                                My favourite band Lovejoy were touring the UK, and I decided to go 
                                and see them live in Newcastle for what was my favourite concert of 2023
                                and also my first concert ever! 
                            </div>
                        </div>
                    </div>
                    <div className="blog_container_after_first">
                        <Link to="/blogs/friendsgiving-2022">
                            <img src={require('../../Assets/friendsgiving-5.jpg')} className="blog_image"
                            alt="thumbnail-for-post"/>
                        </Link>
                        <div className="blog_title_and_desc">
                            <Link to="/blogs/friendsgiving-2022">
                                <div className="blog_title">
                                    <h2><b>Friendsgiving - 2022</b></h2>
                                </div>
                            </Link>
                            <div className="blog_desc_sub">
                                On this wonderful Friday night, me and my friends got together to celebrate 
                                each other company with a wonderful meal, made my em and tyler.
                            </div>
                        </div>
                    </div>
                    <div className="blog_container_after_first">
                        <Link to="/blogs/day-out-seeing-spiderman-2021">
                            <img src={require('../../Assets/food-1.jpg')} className="blog_image"
                            alt="thumbnail-for-post"/>
                        </Link>
                        <div className="blog_title_and_desc">
                            <Link to="/blogs/day-out-seeing-spiderman-2021">
                                <div className="blog_title">
                                    <h2><b>Day out seeing Spiderman - 2021</b></h2>
                                </div>
                            </Link>
                            <div className="blog_desc_sub">
                                This day, me and my friends (Lizzy and Bob) went for a day out in edinburgh
                                during winter season for a nice day out at both Coros (Chocolate Cafe) and 
                                a viewing of the new Spiderman: No Way Home. 
                            </div>
                        </div>
                    </div>
                    <div className="blog_container_after_first">
                        <Link to="/blogs/my-amazing-trip-to-london-2019">    
                            <img src={require('../../Assets/london-1.jpg')} className="blog_image"
                            alt="thumbnail-for-post"/>
                        </Link>
                        <div className="blog_title_and_desc">
                            <Link to="/blogs/my-amazing-trip-to-london-2019" className="">    
                                <div className="blog_title">
                                    <h2><b>My amazing trip to London - 2019</b></h2>
                                </div>
                            </Link>
                            <div className="blog_desc_sub">
                            Before the world turned upside down and inside out, before it was all locked down
                            and we were all hiding away from the scary virus, I got away from Scotland
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <br></br>
                </div>
            </div>
        </>
    )
}

export default Blogs